import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import GroupsIcon from '@mui/icons-material/Groups';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import EventIcon from '@mui/icons-material/Event';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { Button, Dialog, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { CuadrillaCard } from './CuadrillaCard';

export const TablaCuadrillas = ({ currentCuadrillas, setOpen, open }) => {
    return (
        <Table stickyHeader sx={{ minWidth: '100%' }} size="small">
            <TableHead>
                <TableRow>
                    <TableCell align="left" sx={{ fontSize: 20 }}><GroupWorkIcon sx={{ mb: -1, fontSize: 30 }} color='inherit' /> ID</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}><GroupWorkIcon sx={{ mb: -1, fontSize: 30 }} color='warning' /> N. Grupo</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}><EventIcon sx={{ mb: -1, fontSize: 30 }} color='primary' /> Fecha parte de grupo</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}><AssignmentIndIcon sx={{ mb: -1, fontSize: 30 }} color='secondary' /> Cabo</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}><ApartmentIcon sx={{ mb: -1, fontSize: 30 }} color='success' /> Empresa</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}>Validado</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}>Revisado</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}><GroupsIcon sx={{ mb: -1, fontSize: 30 }} color='black' /> Personas</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}><GroupsIcon sx={{ mb: -1, fontSize: 30 }} color='secondary' /> Fichados</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}><GroupsIcon sx={{ mb: -1, fontSize: 30 }} color='warning' /> Pendientes</TableCell>
                    <TableCell align="left" sx={{ fontSize: 20 }}><GroupsIcon sx={{ mb: -1, fontSize: 30 }} color='error' /> No reconocidos</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {currentCuadrillas.map((info, index) => {
                    const totalRecolectores =
                        info.recolectores.no_comprobados.length +
                        info.recolectores.comprobados.length +
                        info.recolectores.error_comprobacion.length;

                    const comprobados = info.recolectores.comprobados.length;
                    const noComprobados = info.recolectores.no_comprobados.length;
                    const errorComprobacion = info.recolectores.error_comprobacion.length;

                    return (
                        <>
                            <TableRow key={index}>
                                <TableCell align="center" sx={{ fontSize: 17 }}>
                                    {info.datos_cuadrilla.id_cuadrilla}
                                </TableCell>
                                <TableCell align="center" sx={{ fontSize: 17 }}>
                                    {info.datos_cuadrilla.nombre_cuadrilla}
                                </TableCell>
                                <TableCell align="left" sx={{ fontSize: 17 }}>
                                    {info.datos_cuadrilla.fecha_cuadrilla}
                                </TableCell>
                                <TableCell align="left" sx={{ fontSize: 17 }}>
                                    {info.datos_cuadrilla.nombre_cabo} {info.datos_cuadrilla.apellidos_cabo}
                                </TableCell>
                                <TableCell align="left" sx={{ fontSize: 17 }}>{info.datos_cuadrilla.nombre_cliente}</TableCell>
                                <TableCell align="left" sx={{ fontSize: 17 }}>
                                    <FormControl variant="standard" fullWidth size='small'>
                                        <InputLabel id="demo-simple-select-standard-label">Validado</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            // value={info.datos_cuadrilla.validado}
                                            // onChange={handleChange}
                                            label="Validado"
                                            defaultValue={info.datos_cuadrilla.validado}
                                        >
                                            <MenuItem value={0}>No</MenuItem>
                                            <MenuItem value={1}>Si</MenuItem>
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell align="left" sx={{ fontSize: 17 }}>
                                    <FormControl variant="standard" fullWidth size='small'>
                                        <InputLabel id="demo-simple-select-standard-label">Revisado</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            // value={age}
                                            // onChange={handleChange}
                                            label="Revisado"
                                            defaultValue={info.datos_cuadrilla.revisado}
                                        >
                                            <MenuItem value={0}>No</MenuItem>
                                            <MenuItem value={1}>Si</MenuItem>
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell align="center" sx={{ fontSize: 17 }}><Button variant='text' onClick={() => setOpen(index)}>{totalRecolectores}</Button></TableCell>
                                <TableCell align="center" sx={{ fontSize: 17 }}><Button variant='text' onClick={() => setOpen(index)}>{comprobados}</Button></TableCell>
                                <TableCell align="center" sx={{ fontSize: 17 }}><Button variant='text' onClick={() => setOpen(index)}>{noComprobados}</Button></TableCell>
                                <TableCell align="center" sx={{ fontSize: 17 }}><Button variant='text' onClick={() => setOpen(index)}>{errorComprobacion}</Button></TableCell>
                            </TableRow>

                            <Dialog
                                open={open === index}
                                onClose={() => setOpen(null)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                fullWidth
                                maxWidth='xxl'
                            >
                                <DialogTitle>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        size={{ xs: 12 }}
                                    >
                                        <Typography variant='h4'>
                                            Informacion del grupo
                                        </Typography>
                                        <IconButton size='medium' onClick={() => setOpen(null)}>
                                            <CloseIcon sx={{ fontSize: 30 }} />
                                        </IconButton>
                                    </Grid>
                                </DialogTitle>
                                <DialogContent>
                                    <CuadrillaCard info={info} />
                                </DialogContent>
                            </Dialog>
                        </>
                    )
                })}
            </TableBody>
        </Table>
    )
}
